import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="text-center p-6 bg-gray-200">
        <a className="text-gray-600 font-semibold" href="/">
          Disease Detection
        </a>
      </div>
    </footer>
  );
};

export default Footer;
